import { render, staticRenderFns } from "./expbar.vue?vue&type=template&id=527b897c&scoped=true&"
import script from "./expbar.vue?vue&type=script&lang=js&"
export * from "./expbar.vue?vue&type=script&lang=js&"
import style0 from "./expbar.vue?vue&type=style&index=0&id=527b897c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527b897c",
  null
  
)

export default component.exports